import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { trackCompletedStep } from '../../helpers/checkoutTracking';
import { STEPS } from '../../constants/checkoutConstants';
import { completeCheck } from '../../actions/checkoutPaymentActions';

import CheckoutCTAButton from '../../components/shared/CheckoutCTAButton';
import CheckoutSaveAndContinue from '../../components/shared/actions/CheckoutSaveAndContinueAction';

class CheckoutCheckSubmit extends Component {
    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(event) {
        const { onCompleteCheck } = this.props;
        event.preventDefault();
        trackCompletedStep(STEPS.STEP_PAYMENT);
        onCompleteCheck();
    }

    render() {
        return (
            <CheckoutCTAButton
                label={<CheckoutSaveAndContinue />}
                marginTop
                dataTn="check-save-button"
                onClick={this.onSubmit}
            />
        );
    }
}

CheckoutCheckSubmit.propTypes = {
    onCompleteCheck: PropTypes.func.isRequired,
};

const ConnectedCheckoutCheckSubmit = connect(null, { onCompleteCheck: completeCheck })(
    CheckoutCheckSubmit
);

export default ConnectedCheckoutCheckSubmit;
